import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import CompanyLogo from "assets/studyGramLogo/studygram_logo.png";
import "./index.css";
import { useLocation ,useNavigate} from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import { Button } from "primereact/button";



const Receipt = () => {
  const [profileData, setProfileData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // MARK: use effect function
  useEffect(() => {
    getProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const contentRef = useRef(null);
  
    const options = {
      filename: "my-document.pdf",
      margin: [1.5, 0, 0, 0],
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
  
    const convertToPdf = () => {
      const content = contentRef.current;
  
      html2pdf().set(options).from(content).save();
    };
    
  // MARK: get data from profile module
  async function getProfile() {
    let auth = localStorage.getItem("session");
    const userInfo = JSON.parse(auth);
    getDoc(doc(dbFirestore, TableName.profile, userInfo.uid))
      .then((response) => {
        setProfileData((prevState) => ({
          ...prevState,
          name: response.data()?.name,
          phone: response.data()?.phone,
          second_phone: response.data()?.second_phone,
          email: response.data()?.email,
          second_email: response.data()?.second_email,
          city: response.data()?.city,
          address: response.data()?.address,
          role: response.data()?.role,
          pinCode: response.data()?.pinCode,
          gstNumber: response.data()?.gstNumber,
          business_name: response.data()?.business_name,
        }));
      })
      .catch((error) => {
        toast.error(error);
      });
  }

  return (
    <div className="modules__main__div">
    <div className="col-12">
      <div className="card modules__card">
        <div className="d-flex">
        <div style={{ marginBottom: "1rem", paddingLeft: "1rem", flexGrow: "1" }}>
          <Button icon="pi pi-arrow-left"
            type="button"
            onClick={() => navigate(-1)}
            className="view__back_button me-3"
          />
        </div>
          <div className="modules__salaryList_main-content mb-4">
        <button
          type="button"
          onClick={convertToPdf}
          className="modules__download_button"
        >
          Download Pdf
        </button>
        </div>
       
        </div>
      {profileData && (
        <div className="main_fee__div " ref={contentRef}>
          <div className="row m-0 p-0">
            <div className="col m-0 p-0">
              <img src={CompanyLogo} alt="" className="company-logo" />
            </div>
            <div
              className="col ps-0 pe-1"
              style={{ fontSize: "0.8rem", maxWidth: "fit-content" }}
            >
              <div>
                <p className="top__right__paragraph pe-0 ms-0">
                  UDYAM : PSA/REG/YNR/LI-Yngr-IV/0264196
                </p>
                <p className="top__right_paragraph ms-0">{profileData.address}</p>
                <p className="top__right_paragraph ms-0">
                  (M) : {profileData.phone}, {profileData.second_phone}
                </p>
                <p className="top__right_paragraph ms-0">{profileData.email}</p>
                <p className="top__right_paragraph ms-0">
                  {profileData.second_email}
                </p>
              </div>
            </div>
          </div>

          <h4 className="mb-2 pt-1 pb-1 ps-2 pe-2 mt-3 main__heading"> receipt </h4>
          <div className="main__form_div">
            <div className="row form__row">
              <div className="col-7">
                <label>receipt no.</label>
                <InputText className="form__input" />
              </div>

              <div className="col-5">
                <label>dated</label>
                <InputText className="form__input form__input-dated" />
              </div>
            </div>

            <div className="row form__row">
              <div className="col d-flex">
                <label className="student_name_label">student name & address</label>

                <p className="form__input form__input_address">{location.state.name} {location.state.address}</p>
              </div>
            </div>

            <div className="row form__row">
              <div className="col form__input_col">
                <label>subject</label>
                <InputText className="form__input form__input_subject" />
              </div>

              <div className="col ps-1 form__input_col">
                <label>fee</label>
                <InputText className="form__input form__input_fee" />
              </div>

              <div className="col ps-1 form__input_col">
                <label>by cash/upi/net banking</label>
                <InputText className="form__input form__input_payment" />
              </div>
            </div>

            <div className="row form__row">
              <div className="col form__input_col">
                <label>cheque no</label>
                <InputText className="form__input form__input_cheque" />
              </div>
              <div className="col ps-1 form__input_col">
                <label>bank</label>
                <InputText className="form__input form__input-bank" />
              </div>
              <div className="col ps-1 form__input_col">
                <label>date</label>
                <InputText className="form__input form__input__date" />
              </div>
            </div>

            <div className="row form__row">
              <div className="col">
                <label>amount in rupees</label>
                <InputText className="form__input form__input_amount" />
              </div>
            </div>

            <div
              className="row"
              style={{ color: "rgba(224,120,29,255)", fontWeight: "700" }}
            >
              <div className="col">
                {/* <img src={RupessPics} alt="" style={{ width: "5rem" }} /> */}
              </div>
              <div className="col" style={{ textAlign: "end" }}>
                <p style={{ fontSize: "1rem" }}>For STUDYGRAM</p>
                <p style={{ fontSize: "1rem", marginTop: "1.5rem"}}>Auth. Signatory</p>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
    </div>
  );
};

export default Receipt;
